let form = document.getElementsByClassName('cmp-form')[0];
form.addEventListener('submit', (e) => {
    const label = document.querySelector('.cheerios-recaptcha');
    const captchaSuccessResponse = label.getAttribute('data-captcha-response');
    if ((captchaSuccessResponse == null) || (captchaSuccessResponse == "")) {
        e.preventDefault();
        document.querySelector('.cheerios-recaptcha-error').innerHTML = label.getAttribute('data-required-message');
        document.querySelector('.cheerios-recaptcha-error').style.display="block";
    }
})